import "../../../../src/pages/design/design-guidelines-styles.css";
import { Button } from 'react-magma-dom';
import * as React from 'react';
export default {
  Button,
  React
};